<script>
var ProgressBar = require("progressbar.js")
export default {
	name: "members-map",
	data() {
		return {
			infoContent: "",
			infoWindowPos: null,
			infoWinOpen: false,
			currentMidx: null,
			//optional: offset infowindow so it visually sits nicely on top of our marker
			infoOptions: {
				pixelOffset: {
					width: 0,
					height: -10
				},
				maxWidth: 200
			}
		}
	},
	mounted() {
		this.progress = new ProgressBar.Line("#progress", {
			easing: "easeInOut",
			duration: 2400,
			strokeWidth: 0.2,
			color: "#b0a288"
		})
		this.progress.animate(1)
		axios
			.get("/fullmembers.json")
			.then(response => {
				let members = response.data.data
				this.$store.commit("members", members)
				this.fitBounds()
			})
			.catch(e => {
				console.log(e)
			})
	},
	computed: {
		members() {
			return this.$store.getters.members.filter(member => {
				return member.lat && member.lng
			})
		}
	},
	methods: {
		fitBounds() {
			var b = new google.maps.LatLngBounds()
			this.members.forEach(member => {
				b.extend({
					lat: +member.lat,
					lng: +member.lng
				})
			})
			this.$refs.mmm.fitBounds(b)
		},
		toggleInfoWindow: function(member, index) {
			this.infoOpen = false
			this.infoWindowPos = {
				lat: +member.lat,
				lng: +member.lng
			}
			this.infoContent = `
				<h5>${member.companyName}</h5>
				<p style="margin-bottom: 0.8rem">${member.street1 ? member.street1 + ", " : ""}
				${member.street2 ? member.street2 + ", <br>" : ""}
				${member.street3 ? member.street3 + ", " : ""}
				${member.city ? member.city + ", <br>" : ""}
				${member.zip ? member.zip + " " : ""}
				${member.country ? member.country + "." : ""}			
				</p>
				<a href="${member.profile}" class="button">View Profile</a>
			`

			if (this.currentMidx == index) {
				this.infoWinOpen = !this.infoWinOpen
			} else {
				this.infoWinOpen = true
				this.currentMidx = index
			}
		}
	}
}
</script>

<template>
    <div>
		<div id="progress" :class="{'hidden' : members.length > 0}"></div>
		<GmapMap
        :zoom="5"
        style="width: 100%; height: 500px"
		:center="{lat:51.9038,lng:0.1966}"
		ref="mmm"
    >
        <GmapMarker
			v-for="(member, index) in members"      
			v-if="member.lat"
            :position="{lat:+member.lat, lng:+member.lng}"
			:key="member.id"
            icon='/images/Map-Spot-Icon.png'
			:title="member.id"
			:clickable="true" 
			@click="toggleInfoWindow(member,index)"
        >
        </GmapMarker>
		<GmapInfoWindow
				:options="infoOptions" 
				:position="infoWindowPos" 
				:opened="infoWinOpen" 
				@closeclick="infoWinOpen=false"
			>
				<div v-html="infoContent"></div>
		</GmapInfoWindow>
    </GmapMap>

	</div>
</template>


<style lang="less">
.vue-map-container {
	* {
		border-style: none;
	}
}
</style>
